/**
 * DelayedFallback — Suspense fallback that waits 150ms before showing.
 * Prevents spinner flash on fast chunk loads.
 */

import { useState, useEffect } from 'react';

export function DelayedFallback() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShow(true), 150);
    return () => clearTimeout(t);
  }, []);

  if (!show) return null;

  return (
    <div
      className="min-h-screen min-h-[100dvh] bg-cream-100 flex items-center justify-center"
      style={{ opacity: 0, animation: 'fadeIn 200ms ease forwards' }}
    >
      <style>{`@keyframes fadeIn { to { opacity: 1; } }`}</style>
      <div className="w-6 h-6 border-2 border-teal-500 border-t-transparent rounded-full animate-spin" />
    </div>
  );
}
